import { Component, Output, Input, EventEmitter } from '@angular/core';
import { RadioModel } from '../../../../personal-data/model/radio.model';

@Component({
  selector: 'app-ion-common-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
})
export class RadioComponent {

  @Input() selectedValue = '';
  @Input() selectedValueCode = '';
  @Input() itens?: RadioModel[];
  @Output() changeRadio = new EventEmitter<string>();
  @Output() valueNameRadio = new EventEmitter<string>();
  @Output() valueNameCode = new EventEmitter<string>();
  @Output() valueAdditionalFields = new EventEmitter<string>();
  error = false;
  @Input() ariaLabel = '';
  @Input() textSearch: string;
  @Input() fieldSearch: string;
  @Input() disabled: boolean;
  @Input() filterIncludes: false;


  public changeValue(event, value, valueAria, valueKey, item){
    this.changeRadio.emit(event.target.value);
    this.valueNameRadio.emit(value);
    this.valueNameCode.emit(valueAria);
    if (item?.additionalFields) {
      this.valueAdditionalFields.emit(item.additionalFields);
    }
    this.setFocus(valueKey);
    
  }

  public trackByKey(_: number, item: RadioModel) {
    return item.key;
  }

  private setFocus(valueKey: string) {
    const id = document.getElementById(valueKey);
    if (id) {
      if (document.querySelector('.plt-ios')) {
        document.body.setAttribute('aria-hidden', 'true');
        setTimeout(() => {
          document.body.removeAttribute('aria-hidden');
          setTimeout(() => {
            id.blur();
            id.focus();
          }, 10);
        }, 800);
      } else {
        setTimeout(() => id.focus(), 50);
      }
    }
  }
}
